import React from 'react';
import { StyleProp, Text, TextStyle, TouchableOpacity } from 'react-native';

export interface ITextWithImage
{

  getStyle : () => StyleProp<TextStyle>;
  getText: () => any;

  bindEvent : (onEvent    : (() => void), 
               bSubscribe : boolean) => void;

  Sample_Image(): JSX.Element | null;

  onPress?: () => void;
}

/*   ====================================================================   */

export default class TextWithImage extends React.Component<ITextWithImage>
 {
  UpdateData()
  {
  var sNewText = this.props.getText();

  if (this.state.sText != sNewText)
      this.setState({sText: sNewText});
  }

  /*   -------------------------------------------------------------------   */
   
  constructor(props)
  {
  super(props);

  this.state      = {sText:this.props.getText()}
  this.UpdateData = this.UpdateData.bind(this);
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  this.props.bindEvent(this.UpdateData, true);
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  this.props.bindEvent(this.UpdateData, false);
  }

  /*   -------------------------------------------------------------------   */

  state = {
      sText: ""
   }

   /*   -------------------------------------------------------------------   */

  render() 
  {
  return(
      <TouchableOpacity style={{flexDirection:'row', alignItems:'center', justifyContent:'center'}}
       onPress={this.props.onPress} //{()=>{if (this.props.onPress) this.props.onPress()}}
       >
      <this.props.Sample_Image/>
      <Text style={this.props.getStyle()}> {this.state.sText} </Text>
      </TouchableOpacity>
      );
  }
}